import { empty } from "../../constants/placeholders"

const getEntityName = (
  entity?: { [key: string]: any } | null,
  byDefault = empty
) => {
  if (!entity) return byDefault

  const fullName = [entity?.first_name, entity?.middle_name, entity?.last_name]
    ?.filter(Boolean)
    ?.join(" ")

  return fullName || entity?.name || byDefault
}

export { getEntityName }
